import React, {useState} from 'react';

import {useMutation} from "@apollo/client";
import { Button, message, Spin } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import cls from './Bonus.module.scss'
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';

export default function Bonus({id, value = 0, child}) {

    const [bonus, setBonus] = useState(value);

    const [updateMutation, {loading}] = useMutation(child ? UPDATE_CLIENT : UPDATE_PARENT);

    async function onMinus() {

        const newBonus = Math.max((bonus -1), 0)

        await updateMutation({
            variables: {
                data: {bonus: newBonus},
                id: id,
            },
            onCompleted: () => {
                setBonus(newBonus);
            },
            onError: (error) => {
                message.error('Ошибка списания бонусов');
                console.error(error);
            },
        });

    }

    async function onPlus() {

        const newBonus = bonus + 1;

        await updateMutation({
            variables: {
                data: {bonus: newBonus},
                id: id,
            },
            onCompleted: () => {
                setBonus(newBonus);
            },
            onError: (error) => {
                message.error('Ошибка начисления бонусов');
                console.error(error);
            },
        });

    }

    return (
        <div className={cls.bonus}>
            <Button icon={<MinusOutlined />} type={'link'} onClick={onMinus} className={cls.button} />
            <span>
                {loading ? <Spin spinning/> : bonus}
            </span>
            <Button icon={<PlusOutlined />} type={'link'} onClick={onPlus} className={cls.button} />
        </div>
    )

}


